// @ts-nocheck
import { createOrderSlice } from 'pages/orderShared/createOrderSlice';

const { slice, initialState: _initialState } = createOrderSlice({
	name: 'orderBySku',
	columnKeys: ['sku', 'store', 'warehouse', 'order'],
	hasAvailability: true,
});

export const initialState = _initialState;
export default slice;

export const { setColumns, setOrderData, appendOrderData, setAvailability, setLoading, clearData } = slice.actions;
